import React, { useRef, useEffect } from "react";
import AceEditor from "react-ace";
import "ace-builds/src-min-noconflict/mode-python";
import "ace-builds/src-min-noconflict/mode-html";
import "ace-builds/src-min-noconflict/mode-javascript";
import "ace-builds/src-min-noconflict/mode-css";
import "ace-builds/src-min-noconflict/mode-php";
import "ace-builds/src-min-noconflict/mode-java";
import "ace-builds/src-min-noconflict/mode-sql";
import "ace-builds/src-min-noconflict/mode-c_cpp";
import 'ace-builds/src-min-noconflict/theme-tomorrow_night_bright';
import "ace-builds/src-min-noconflict/mode-markdown";

interface CustomEditorProps {
  value: string;
  onChange: (value: string) => void;
  mode: string;
  height?: string;
  review?: {
    feedback: string;
    is_success: boolean;
    errors: Array<{
      line_number: number;
      type: string;
      comment: string;
    }>;
    suggestions: Array<{
      line_number: number;
      type: string;
      comment: string;
    }>;
    infos: Array<{
      line_number: number;
      comment: string;
    }>;
  };
}

const CustomEditor = ({ 
  value, 
  onChange, 
  mode, 
  height = "100%",
  review
}: CustomEditorProps) => {
  const editorRef = useRef<AceEditor>(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.editor && review) {
      // Convert annotations to Ace editor format
      const aceAnnotations = [];
      
      // Add errors
      if (review.errors) {
        review.errors.forEach(error => {
          aceAnnotations.push({
            row: error.line_number - 1,
            column: 0,
            text: error.comment,
            type: "error"
          });
        });
      }
      
      // Add suggestions
      if (review.suggestions) {
        review.suggestions.forEach(suggestion => {
          aceAnnotations.push({
            row: suggestion.line_number - 1,
            column: 0,
            text: suggestion.comment,
            type: "warning"
          });
        });
      }
      
      // Add infos
      if (review.infos) {
        review.infos.forEach(info => {
          aceAnnotations.push({
            row: info.line_number - 1,
            column: 0,
            text: info.comment,
            type: "info"
          });
        });
      }
      
      // Set annotations in editor
      editorRef.current.editor.session.setAnnotations(aceAnnotations);
    }
  }, [review]);

  return (
    <AceEditor
      ref={editorRef}
      fontSize={14}
      width="100%"
      theme="tomorrow_night_bright"
      mode={mode}
      value={value}
      onChange={onChange}
      height={height}
      style={{
        backgroundColor: "#040034",
        color: "#DEDEDE"
      }}
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        showLineNumbers: true,
        tabSize: 2,
        showPrintMargin: false,
      }}
      wrapEnabled
    />
  );
};

export default CustomEditor;
